<template src="./template.html"></template>

<script>
/* eslint-disable */
export default {
  computed: {
    crumbs: function() {
      if( this.$route.meta.hasOwnProperty('breadCrumb') ){
        let breads = this.$route.meta.breadCrumb;
        let breadcrumbs = breads.reduce((breadcrumbArray, bread, idx) => {
          // Crumb has params
          let paramText = '';
          if( bread.hasOwnProperty('param') ){
            paramText = this.$route.params[bread.param];
          }
          
          // Crumb item
          breadcrumbArray.push({
            to: bread.link,
            text: bread.text + paramText,
          });
          return breadcrumbArray;
        }, []);
        return breadcrumbs;
      } else {
        return false;
      }
    },
  },
}
</script>
